;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$state", "$transition$", "$window", "StateFactory", "portalLayoutService", "projectTrackerService"];
  angular.module('app.project').controller('ProjectTrackerPage', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $state,
    $transition$,
    $window,
    StateFactory,
    portalLayoutService,
    projectTrackerService
  ) {
    var ctrl = this

    ctrl.state = new StateFactory(['loading', 'loaded', 'error'])

    ctrl.back = back

    init()

    function init() {
      ctrl.projectId = $state.params.id
      // Read once here: ui-router nulls $transition$ once the transition ends
      ctrl.cameFromFolder =
        $transition$.from().name === 'project' &&
        $transition$.params('from').id === ctrl.projectId
      ctrl.state.loading()

      // The page owns Back so it also shows on the loading and error screens
      portalLayoutService.setBack(back)
      $scope.$on('$destroy', portalLayoutService.clearBack)

      projectTrackerService
        .getByProject(ctrl.projectId)
        .then(function(trackers) {
          ctrl.tracker = _.find(trackers, { id: $state.params.trackerId })
          if (ctrl.tracker) {
            ctrl.state.loaded()
          } else {
            ctrl.state.error()
          }
        })
        .catch(function() {
          ctrl.state.error()
        })
    }

    function back() {
      if (ctrl.cameFromFolder) {
        $window.history.back()
      } else {
        $state.go('project', { id: ctrl.projectId })
      }
    }
  }
})()
